var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMenuMotelWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3262 28.0625C22.5059 28.0625 28.3262 22.2422 28.3262 15.0625C28.3262 7.8828 22.5059 2.0625 15.3262 2.0625C8.14647 2.0625 2.32617 7.8828 2.32617 15.0625C2.32617 22.2422 8.14647 28.0625 15.3262 28.0625ZM15.3262 30.0625C23.6104 30.0625 30.3262 23.3468 30.3262 15.0625C30.3262 6.77823 23.6104 0.0625 15.3262 0.0625C7.0419 0.0625 0.326172 6.77823 0.326172 15.0625C0.326172 23.3468 7.0419 30.0625 15.3262 30.0625Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64453 8.89844H11.8585L15.253 17.1801H15.3974L18.792 8.89844H22.0059V21.2246H19.4781V13.2018H19.3758L16.1859 21.1644H14.4646L11.2747 13.1717H11.1724V21.2246H8.64453V8.89844Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMenuMotelWhite);
export default __webpack_public_path__ + "static/media/new-menu-motel-white.5ef287ebb9dc63a0d1bac047c41b1703.svg";
export { ForwardRef as ReactComponent };